import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";
import { useTranslation } from "react-i18next";

interface OfflineSyncButtonProps {
  isProcessing: boolean;
  onSync: () => void;
}

export function OfflineSyncButton({
  isProcessing,
  onSync,
}: OfflineSyncButtonProps) {
  const { t } = useTranslation();

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={onSync}
      disabled={isProcessing}
      className="w-full h-8 px-3 text-xs"
    >
      {isProcessing ? (
        <>
          <RefreshCw className="h-3 w-3 animate-spin mr-1" />
          {t("offlineStatus.syncing")}
        </>
      ) : (
        <>
          <RefreshCw className="h-3 w-3 mr-1" />
          {t("offlineStatus.syncNow")}
        </>
      )}
    </Button>
  );
}
